import { VuexContext } from "@mv/flow-shared-utils/types/vuex";
import fetch from "@mv/flow-shared-utils/functions/fetch";
import { setApiCatalog, setExternalSystems } from "./types";
import { handleErrors } from "@/utils/handle-errors";

export const loadExternalSystems = () => ({ type: "fetchExternalSystems" });
export const loadVersionsBySystem = (system: string) => ({ type: "fetchVersionsBySystem", system });
export const loadApiCatalogBySystemAndVersion = (system: string, version: string) => ({ type: "fetchApiCatalogBySystemAndVersion", system, version });
export const loadCatalogSwagger = () => ({ type: "loadCatalogSwagger" });

export const actions = {
  fetchExternalSystems(context: VuexContext) {
    return fetch(`core/api/external-api/external-system`)
      .then(handleErrors)
      .then((data) => {
        context.commit(setExternalSystems, data);
      });
  },

  fetchVersionsBySystem(_context: VuexContext, { system }: { system: string }) {
    return fetch(`core/api/external-api/system?system=${system}`)
      .then(handleErrors)
      .then((data) => {
        return data;
      });
  },

  fetchApiCatalogBySystemAndVersion(context: VuexContext, { system, version }: { system: string; version: string }) {
    return fetch(`core/api/external-api/system-version?system=${system}&version=${version}`)
      .then(handleErrors)
      .then((data) => {
        context.commit(setApiCatalog, JSON.parse(data.swagger));
      });
  },

  loadCatalogSwagger(context: VuexContext) {
    return fetch("core/api/external-api/catalog/swagger")
      .then(handleErrors)
      .then((data) => {
        context.commit(setApiCatalog, data);
      })
      .catch((err) => {
        throw err;
      });
  },
};
